// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Denmark from '../_raw/flag/icon_flag_denmark.png';

export default () => <img src={Denmark} alt="Denmark" />;
